'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _style = require('./style');

var ToggleButtonStyles = _reactStyle2['default'].create({
  normalStyle: {
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    cursor: 'pointer',
    display: 'block',
    position: 'relative'
  },

  lineStyle: {
    backgroundColor: _style.Colors.grey.P700,
    height: '1px',
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    left: 0,
    position: 'absolute',
    top: '10px',
    width: '38px'
  },

  circleStyle: {
    border: 'solid 2px',
    borderColor: _style.Colors.grey.P700,
    borderRadius: '50%',
    height: '16px',
    backgroundColor: _style.Colors.grey.P100,
    left: 0,
    position: 'absolute',
    top: 0,
    width: '16px',
    transition: 'left .28s cubic-bezier(0.4, 0, 0.2, 1)',
    willChange: 'left'
  },

  childStyle: {
    paddingLeft: '16px'
  },

  childBigStyle: {
    paddingLeft: '32px'
  },

  checkedStyle: {
    left: '20px'
  },

  circlePositionStyle: {
    display: 'inline-block',
    position: 'absolute',
    right: 0,
    top: 0,
    width: '40px'
  },

  onButtonStyle: {
    backgroundColor: _style.Colors.grey.P700,
    borderRadius: '50%',
    height: '20px',
    left: '-2px',
    position: 'absolute',
    top: '-2px',
    transform: 'scale(0)',
    transition: 'transform ease 0.28s',
    width: '20px',
    willChange: 'transform'
  },

  onButtonFillStyle: {
    transform: 'scale(1)'
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this.state = {
      checked: false
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'onClick',
    value: function onClick() {
      var onChange = this.props.onChange;
      var checked = this.state.checked;

      this.isChecked = !checked;
      this.setState({ checked: !checked });
      if (onChange) {
        onChange({ checked: this.isChecked });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var styles = _props.styles;
      var checked = this.state.checked;

      var circleStyle = [ToggleButtonStyles.circleStyle];
      var onButtonStyle = [ToggleButtonStyles.onButtonStyle];

      if (checked) {
        circleStyle.push(ToggleButtonStyles.checkedStyle);
      }

      if (styles) {
        onButtonStyle = onButtonStyle.concat(styles.onButtonStyle);
      }

      if (checked) {
        onButtonStyle.push(ToggleButtonStyles.onButtonFillStyle);
      }

      return _react2['default'].createElement(
        'div',
        {
          onClick: this.onClick.bind(this),
          styles: ToggleButtonStyles.normalStyle },
        children,
        _react2['default'].createElement(
          'div',
          { styles: ToggleButtonStyles.circlePositionStyle },
          _react2['default'].createElement('div', { styles: ToggleButtonStyles.lineStyle }),
          _react2['default'].createElement(
            'div',
            { styles: circleStyle },
            _react2['default'].createElement('div', { styles: onButtonStyle })
          )
        )
      );
    }
  }], [{
    key: 'displayName',
    value: 'ToggleButton',
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      children: _react.PropTypes.node,
      onChange: _react.PropTypes.func,
      styles: _react.PropTypes.object
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/ToggleButton.js
 ** module id = 220
 ** module chunks = 0
 **/